import { IModuleConfig } from "../../../utilites/module";
import {
  STREAM_ROUTER_ROOT,
  STREAM_ROUTER_NEW,
  VOD_ROUTER_NEW,
  STREAM_ROUTER_EDIT,
  VOD_ROUTER_EDIT,
} from "./constants";
import StreamUpcomming from "./StreamUpcomming";
import StreamPast from "./StreamPast";
import StreamVoDRoot from "./StreamVoDRoot";
import StreamVoD from "./StreamVoD";
import StreamRoot from "./StreamRoot";
import StreamNew from "./StreamNew";
import VideoOnDemandNew from "./Video/VideoOnDemandNew";
import VideoOnDemandEdit from "./VideoOnDemandEdit";
import StreamEdit from "./StreamEdit";

export const CustomStream: IModuleConfig = {
  router: [
    {
      path: STREAM_ROUTER_ROOT,
      component: StreamRoot,
      indexRoute: {
        onEnter: (nextState, replace) =>
          replace({pathname: STREAM_ROUTER_ROOT + "/upcoming"}),
      },
      childRoutes: [
        {
          path: "upcoming",
          component: StreamUpcomming,
        },
        {
          path: "past",
          component: StreamPast,
        },
        {
          path: "vod",
          component: StreamVoDRoot,
        },
        {
          path: "vod/category/:category_id",
          component: StreamVoDRoot,
          }
      ],
    },
    {
      path: STREAM_ROUTER_NEW,
      component: StreamNew,
    },
    {
      path: VOD_ROUTER_NEW,
      component: VideoOnDemandNew,
    },
    {
      path: STREAM_ROUTER_EDIT,
      component: StreamEdit,
    },
    {
      path: VOD_ROUTER_EDIT,
      component: VideoOnDemandEdit,
    },
  ],
};

export default CustomStream;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/index.ts